function getUrlBase () {
  if (process.env.VUE_APP_NODE_ENV === 'development') return 'https://conversations.cloudtask.com/'
  if (process.env.VUE_APP_NODE_ENV === 'local_development') return 'http://localhost:3401/'
  if (process.env.VUE_APP_NODE_ENV === 'test') return 'https://conversations.cloudtask.com/'
  return 'https://conversations.cloudtask.com/'
}

const UrlBase = getUrlBase()

export { UrlBase }
